import React from 'react';
import { connect } from 'react-redux';

import { selectIsSearchInShop, selectRequestUrlPath } from 'store/meta/selectors';

import BreadCrumbsSeo from './BreadCrumbs';
import DeviceListSeo from './DeviceList';
import ProductDetailsSeo from './DevicePreview';
import ArticlesSeo from './ArticleList';
import Search from './Search';
import Main from './Main';

type Props = {
  path: string;
  search: boolean;
};

const _Seo: React.FC<Props> = ({ path, search }) => {
  return (
    <>
      {path === '/shop/' ?
        <Main />
      : <BreadCrumbsSeo />}
      {path.includes('catalog') && <DeviceListSeo />}
      {path.includes('details') && <ProductDetailsSeo />}
      {path.includes('obzory') && <ArticlesSeo />}
      {search && <Search />}
    </>
  );
};

const mapStateToProps = (state) => ({
  path: selectRequestUrlPath(state),
  search: selectIsSearchInShop(state),
});

export const Seo = connect(mapStateToProps)(_Seo);
